import { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { IconStyle } from '../Icons/Icons';
import IconButton from '../IconButton/IconButton';
import { BRAND_THEME } from '../IconButton/types/enums';
import { SocialMediaIconProps } from './types/propTypes';
import styles from './SocialMediaIcon.module.scss';
import { SocialPlateforms } from './types/enums';

const cx = classNames.bind(styles);

const SocialMediaIcon = forwardRef<HTMLSpanElement, SocialMediaIconProps>((props: SocialMediaIconProps, ref) => {
  const isSolid = [
    SocialPlateforms.EMAIL,
    SocialPlateforms.LINK,
    SocialPlateforms.LINK_COPIED,
    SocialPlateforms.MORE,
  ].includes(props.iconName);
  const CClassname = cx('social-media-icon', {
    [`social-${props.iconName}`]: true,
    [`icon-${props.iconName}`]: true,
  });
  return (
    <IconButton
      containerClassName={CClassname}
      className={styles['social-icon']}
      iconStyle={isSolid ? IconStyle.SOLID : IconStyle.BRANDS}
      theme={BRAND_THEME.BRAND}
      {...props}
      ref={ref}
    />
  );
});

SocialMediaIcon.displayName = 'SocialMediaIcon';
export default SocialMediaIcon;
export { SocialPlateforms };
export type { SocialMediaIconProps };
